import React from 'react';
import { GuideLinesIcon } from '@assets/icon';
import './InstructionGuideGrid.scss';

export type InstructionGuideItem = {
  function_name?: string;
  question?: string;
  title?: string;
  name?: string;
  iconUrl?: string;
  imageUrl?: string;
  icon?: string;
  [key: string]: unknown;
};

interface InstructionGuideGridProps {
  items?: Array<InstructionGuideItem | string>;
  isLoading?: boolean;
  isThinking?: boolean;
  onItemClick: (item: InstructionGuideItem | string) => void;
}

const SKELETON_COUNT = 4;

const getInstructionLabel = (item: InstructionGuideItem | string): string => {
  if (typeof item === 'string') return item.trim();
  return String(item.function_name || item.question || item.title || item.name || '').trim();
};

const getInstructionIconSrc = (item: InstructionGuideItem | string): string | undefined => {
  if (typeof item === 'string') return undefined;
  const src = item.iconUrl || item.imageUrl || (typeof item.icon === 'string' ? item.icon : undefined);
  return typeof src === 'string' && src.trim() ? src.trim() : undefined;
};

const InstructionGuideGrid: React.FC<InstructionGuideGridProps> = ({
  items = [],
  isLoading = false,
  isThinking = false,
  onItemClick,
}) => {
  const displayItems = items.filter((item) => Boolean(getInstructionLabel(item)));

  if (isLoading && displayItems.length === 0) {
    return (
      <div className="instruction-guide-grid">
        <div className="instruction-guide-grid__list">
          {Array.from({ length: SKELETON_COUNT }).map((_, index) => (
            <div key={`skeleton-${index}`} className="instruction-guide-card instruction-guide-card--skeleton" />
          ))}
        </div>
      </div>
    );
  }

  if (displayItems.length === 0) {
    return null;
  }

  return (
    <div className="instruction-guide-grid">
      <div className="instruction-guide-grid__list">
        {displayItems.map((item, index) => {
          const label = getInstructionLabel(item);
          const iconSrc = getInstructionIconSrc(item);

          return (
            <button
              key={`${label}-${index}`}
              type="button"
              className={`instruction-guide-card${isThinking ? ' instruction-guide-card--disabled' : ''}`}
              onClick={() => {
                if (!isThinking) onItemClick(item);
              }}
              disabled={isThinking}
            >
              <span className="instruction-guide-card__icon" aria-hidden>
                {iconSrc ? (
                  <img src={iconSrc} alt="" />
                ) : (
                  <GuideLinesIcon />
                )}
              </span>
              <span className="instruction-guide-card__label">{label}</span>
            </button>
          );
        })}
      </div>

    </div>
  );
};

export default InstructionGuideGrid;
